import { mapState, mapActions } from 'vuex'
import gql from 'graphql-tag'

export default {
  name: 'ModalRegister',
  data () {
    return {
      isLoading: false,
      inputConfirm: '',
      labelConfirm: 'Registrar este arquivo'
    }
  },
  computed: {
    ...mapState({
      isVisibleModalRegister: ({ modal }) => modal.isVisibleModalRegister,
      idFileRegister: ({ importFile }) => importFile.idFileRegister,
      campaignId: ({ campaign }) => campaign.campaign.id
    })
  },
  methods: {
    ...mapActions('importFile', ['getAllFiles', 'getAllStatus', 'registerFile']),

    toggle () {
      this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_REGISTER', false)
      this.inputConfirm = ''
      this.labelConfirm = 'Registrar este arquivo'
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    regiterFileID (id) {
      this.isLoading = true
      this.$api.mutate({
        mutation: gql`mutation registerPaymentSlip( $importFileId: ID! ) {
          registerPaymentSlip( importFileId: $importFileId ) {
            result {
              json
              status
            }
          }
        }`,
        variables: {
          importFileId: id
        },
      }).then(res => {
        this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'success')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Arquivo Resgistrado com sucesso!')
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_REGISTER', false)
        this.scrollToTop()
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
        }, 8000)
        this.isLoading = false
        this.getAllFiles({page: 1, limit: 10, campaignId: this.campaignId})
      }).catch(e => {
        this.$store.commit('files/SET_FILE_DATA', this.fileDataFromTable)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Falha em registrar arquivo!')
        this.isLoading = false
      })
    }
  }
}
